import { render } from "./App.vue?vue&type=template&id=66b361b3"
const script = {}

import exportComponent from "/Users/alexanderwodarz/backup/projekte/swifud_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__